import { WorkspaceRole } from "@supernova-studio/model";
import { z } from "zod";
export const DTODesignSystemRole = z.enum([
    WorkspaceRole.Admin,
    WorkspaceRole.Contributor,
    WorkspaceRole.Creator,
    WorkspaceRole.Viewer,
]);
